// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.register .card {
  box-shadow: 6px 7px 10px rgba(0, 0, 0, 0.3);
  border: 0px solid #c8ced3;
  border-radius: 1.25rem;
}
.register .logo img {
  width: 40%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/register/register.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACE,2CAAA;EACA,yBAAA;EACA,sBAAA;AACJ;AAEE;EACE,UAAA;AAAJ","sourcesContent":[".register {\r\n  min-height: 100vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  .card {\r\n    box-shadow: 6px 7px 10px rgba(0, 0, 0, 0.3);\r\n    border: 0px solid #c8ced3;\r\n    border-radius: 1.25rem;\r\n  }\r\n\r\n  .logo img {\r\n    width: 40%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
